"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeOldStatus = exports.getStatusColor = exports.getFullStatus = void 0;

var getFullStatus = function getFullStatus(status) {
  switch (status) {
    case "PA":
      return "Por asignar";

    case "AS":
    case "Assigned":
      return "Asignado";

    case "CA":
    case "IN_PROGRESS":
      return "Capturando";

    case "IE":
    case "QF":
      return "Información enviada";

    case "RC":
    case "RF":
      return "Rechazado coordinador";

    case "AC":
    case "AF":
      return "Aprobado coordinador";

    case "RA":
      return "Rechazado auditor";

    case "AA":
      return "Aprobado auditor";

    case "RP":
      return "Rechazado proveedor";

    case "AP":
      return "Aprobado proveedor";

    case "RCA":
      return "Rechazado cadena";

    case "ACA":
      return "Aprobado cadena";

    case "R":
      return "Por recibir/recibido";

    case "Ex":
      return "Exportado";

    case "NS":
      return "No solicitado";

    case "SAC":
      return "Solicitud Auditoría Content-oh!";

    case "AAC":
      return "Aprobado Auditoría Content-oh!";

    case "RAC":
      return "Rechazado Auditoría Content-oh!";

    case "FAP":
      return "Finalización Auditoría por Proveedor";

    default:
      return "";
  }
};

exports.getFullStatus = getFullStatus;

var getStatusColor = function getStatusColor(status) {
  switch (status) {
    case "PA":
      return "#A93226";

    case "AS":
    case "Assigned":
      return "#884EA0";

    case "CA":
    case "IN_PROGRESS":
      return "#2471A3";

    case "IE":
    case "QF":
      return "#1ABC9C";

    case "RC":
    case "RF":
      return "#229954";

    case "AC":
    case "AF":
      return "#F1C40F";

    case "RA":
      return "#34495E";

    case "AA":
      return "#E33AA9";

    case "RP":
      return "#BDC3C7";

    case "AP":
      return "#ED9A4D";

    case "RCA":
      return "#71DE56";

    case "ACA":
      return "#839192";

    case "R":
      return "#D35400";

    case "NS":
      return "black";

    case "Ex":
      return "#09CAD8";

    case "SAC":
      return "#2471A3";

    case "AAC":
      return "#1ABC9C";

    case "RAC":
      return "#229954";

    case "FAP":
      return "#F1C40F";

    default:
      return "white";
  }
};

exports.getStatusColor = getStatusColor;

var removeOldStatus = function removeOldStatus(object) {
  var keys = Object.keys(object || {}) || [];
  keys === null || keys === void 0 ? void 0 : keys.forEach(function (status) {
    switch (status) {
      case "Assigned":
        object["AS"] = object["AS"] + object["Assigned"];
        delete object["Assigned"];
        break;

      case "IN_PROGRESS":
        object["CA"] = object["CA"] + object["IN_PROGRESS"];
        delete object["IN_PROGRESS"];
        break;

      case "QF":
        object["IE"] = object["IE"] + object["QF"];
        delete object["QF"];
        break;

      case "RF":
        object["RC"] = object["RC"] + object["RF"];
        delete object["RF"];
        break;

      case "AF":
        object["AC"] = object["AC"] + object["AF"];
        delete object["AF"];
        break;

      default:
        break;
    }
  });
  return object;
};

exports.removeOldStatus = removeOldStatus;